import { Button, Card, Col, DatePicker, Descriptions, Form, Input, Modal, Row, Select, Table, Tabs } from "antd"
import { ColumnProps } from "antd/lib/table"
import React, { useEffect, useRef, useState } from "react";
import { LotCodeOpsService } from '../../../../../../shared-services/production/src/lib/lot-code-ops.service'
import DescriptionsItem from "antd/lib/descriptions/Item";
import { useHistory } from 'react-router-dom';
import { AssignLotMaterialReq, MaterialInfoReq } from "@gtpl/shared-models/production-management";
import { PriorityEnum, QualityTypeEnum } from "@gtpl/shared-models/common-models";
import { get } from "http";
import { AlertMessages } from "@gtpl/shared-utils/alert-messages";
import {ProductService} from '@gtpl/shared-services/masters'
import { render } from "react-dom";
import { SearchOutlined } from '@ant-design/icons';
import  Highlighter  from 'react-highlight-words';
import moment from "moment";
import { SortOrder } from 'antd/lib/table/interface';

const { TabPane } = Tabs;
const {Option} = Select;

export const LotView = () => {
    const [page, setPage] = React.useState(1);
    const [openTabInfo,setOpenTabInfo] = useState<any[]>([])
    const [assignedTabInfo,setAssignedTabInfo] = useState<any[]>([])
    const [tabName,setTabName] = useState<string>('degummingInfo')
    const lotService = new LotCodeOpsService()
    const [assignMaterialModal,setAssignMaterialModal] = useState<boolean>(false)
    const [materialInfo,setMaterialInfo] = useState<any[]>([])
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const userName = JSON.parse(localStorage.getItem('username') || '{}');
    const plantId = JSON.parse(localStorage.getItem('unit_id') || '{}');
    const [selectedRows,setSelectedRows] = useState<any[]>([])
    const [selectedLotInfo,setSelectedLotInfo] = useState<any>()
    let history = useHistory();
    const [form] = Form.useForm()
    const [degumInfoForm] = Form.useForm()
    const [workOrderNumbers,setWorkOrderNumbers] = useState<any[]>([])
    const [variants,setVariants] = useState<any[]>([])
    const [lotVariants,setLotVariants] = useState<any[]>([])
    const productService = new ProductService()
    const [selectedLotQty,setSelectedLotQty] = useState<number>(0)
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    useEffect(() => {
        // getOpenTabInfo()
        getMaterialToAssign()
        getVariant()
        getWorkOrdreNumbers()
        getAssignedLotInfo()
    },[])

    const getLotVariants = () => {
        productService.getAllActiveProducts().then(res => {
            if(res.status){
                setLotVariants(res.data)
            }else{
                setLotVariants([])
            }
        })
    }

    const getWorkOrdreNumbers = () => {
        lotService.getWorkOrderDropdown().then(res => {
            if(res.status){
                setWorkOrderNumbers(res.data)
            }else{
                setWorkOrderNumbers([])
            }
        })
    }

    
    const getVariant = () => {
        lotService.getVariantDropdown().then(res => {
            if(res.status){
                setVariants(res.data)
            }else{
                setVariants([])
            }
        })
    }

    const getOpenTabInfo = () => {
        lotService.getOpenLotsInfo().then(res => {
            if(res.status){
                setOpenTabInfo(res.data)
            }else{
                setOpenTabInfo([])
            }
        })
    }

    const getAssignedLotInfo = () => {
        lotService.getAssignedLotInfo().then(res => {
            if(res.status){
                setAssignedTabInfo(res.data)
            }else{
                setAssignedTabInfo([])
            }
        })
    }

    const getMaterialToAssign = () => {
        const workOrderNumber = tabName == 'degummingInfo' ? degumInfoForm.getFieldValue('workOrderNumber') : form.getFieldValue('workOrderNumber')
        const variant = tabName == 'degummingInfo' ? degumInfoForm.getFieldValue('variant') : form.getFieldValue('variant')
        const quality = tabName == 'degummingInfo' ? degumInfoForm.getFieldValue('quality') : form.getFieldValue('quality')
        const req = new MaterialInfoReq(workOrderNumber,variant,quality,plantId)
        lotService.getMaterialForLot(req).then(res => {
            if(res.status){
                setMaterialInfo(res.data)
            }else{
                setMaterialInfo([])
            }
        })
    }

    function handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    function handleReset(clearFilters) {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex: string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : false,
        onFilterDropdownVisibleChange: visible => {
            if (visible) { setTimeout(() => searchInput.current.select()); }
        },
        render: text =>
            text ? (
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text.toString()}
                    />
                ) : text
            ) : null
    });

    const columns : ColumnProps<any>[] = [
        {
            title: 'S No',
            key: 'sno',
            width: '70px',
            align: 'left',
            responsive: ['md'],
            render: (text, object, index) => (page - 1) * 10 + (index + 1)
        },
        {
            title:'Lot Date',
            dataIndex:'lotDate',
            sorter: (a, b) => moment(a.lotDate).unix() - moment(b.lotDate).unix(),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('lotDate'),
            render:(text,record) => {
                return(
                    <>{record.lotDate ? moment(record.lotDate).format('YYYY-MM-DD') : '-'}</>
                )
            }
        },
        {
            title:'Lot Number',
            dataIndex:'lotNumber',
            sorter: (a, b) => a.lotNumber.length - b.lotNumber.length || a.lotNumber.localeCompare(b.lotNumber),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('lotNumber')
        },
        {
            title:'Lot Type',
            dataIndex:'lotType',
            sorter: (a, b) => a.lotType.length - b.lotType.length || a.lotType.localeCompare(b.lotType),
            sortDirections: ['descend', 'ascend'],
            filters:[
                {text:'Carding',value:'Carding'},
                {text:'Dressing',value:'Dressing'},
                {text:'BALE',value:'BALE'}
            ],
            filterMultiple: true,
            onFilter: (value, record) => {
                return record.lotType == value;
            },
        },
        {
            title:'Remarks',
            dataIndex:'remarks',
            sorter: (a, b) => a.remarks.length - b.remarks.length || a.remarks.localeCompare(b.remarks),
            sortDirections: ['descend', 'ascend'],
        },
        {
            title:'Ex-Factory Date',
            dataIndex:'exFactoryDate',
            sorter: (a, b) => moment(a.exFactoryDate).unix() - moment(b.exFactoryDate).unix(),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('exFactoryDate'),
            render:(text,record) => {
                return(
                    <>{record.exFactoryDate ? moment(record.exFactoryDate).format('YYYY-MM-DD') : '-'}</>
                )
            }
        },
        {
            title:'Priority',
            dataIndex:'priority',
            sorter: (a, b) => a.priority?.length - b.priority?.length || a.priority?.localeCompare(b.priority),
            sortDirections: ['descend', 'ascend'],
            filters: Object.values(PriorityEnum).map(val => ({
                text: val,
                value: val
            })),
            filterMultiple: true,
            onFilter: (value, record) => {
                return record.priority == value;
            },
            render:(text,record) => {
                return(<>{text ?? '-'}</>)
            }
        },
        ...(tabName == 'Assigned' ? [
            {
                title:'Material Assigned Date',
                dataIndex:'materialAssignDate',
                sorter: (a, b) => moment(a.materialAssignDate).unix() - moment(b.materialAssignDate).unix(),
                sortDirections: ['descend', 'ascend'] as SortOrder[],
                ...getColumnSearchProps('materialAssignDate'),
                render:(text,record) => {
                    return(
                        <>{record.materialAssignDate ? moment(record.materialAssignDate).format('YYYY-MM-DD') : '-'}</>
                    )
                }
            },
            // {
            //     title:'WorkOrder',
            //     dataIndex:'workOrder'
            // },
            {
                title:'Variant',
                dataIndex:'lotVariant',
                sorter: (a, b) => a.lotNumber.length - b.lotNumber.length || a.lotNumber.localeCompare(b.lotNumber),
                // sortDirections: ['descend', 'ascend'],
                ...getColumnSearchProps('lotNumber')
            },
            // {
            //     title:'Quality',
            //     dataIndex:'quality'
            // },
            {
                title:'Quantity',
                dataIndex:'lotQty',
                sorter:(a,b) => a.lotQty - b.lotQty,
                render:(text,record) => {
                    return(
                        <>{Number(record.lotQty)}</>
                    )
                }
            }
        ] : []),
        ...(tabName == 'Open' ? [
            {
                title:'Action',
                dataIndex:'action',
                render:(text:any,record:any) => {
                    return(
                        <Button onClick={() => {onAssignMaterial(record)}}>Assign Material</Button>
                    )
                }
            }
        ] : [])
    ]

    const assignMaterialColumns : ColumnProps<any>[] = [
        {
            title: 'S No',
            key: 'sno',
            width: '70px',
            align: 'left',
            responsive: ['md'],
            render: (text, object, index) => (page - 1) * 10 + (index + 1)
        },
        {
            title:'Work Order Number',
            dataIndex:'workOrderNumber',
            sorter: (a, b) => a.workOrderNumber.length - b.workOrderNumber.length || a.workOrderNumber.localeCompare(b.workOrderNumber),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('workOrderNumber')
        },
        // {
        //     title:'Ex-Factory Date',
        //     dataIndex:'exFactoryDate',
        //     sorter: (a, b) => moment(a.exFactoryDate).unix() - moment(b.exFactoryDate).unix(),
        //     sortDirections: ['descend', 'ascend'],
        //     ...getColumnSearchProps('exFactoryDate'),
        //     render:(text,record) => {
        //         return(
        //             <>{record.exFactoryDate ? moment(record.exFactoryDate).format('YYYY-MM-DD') : '-'}</>
        //         )
        //     }
        // },
        {
            title:'Variant',
            dataIndex:'variant',
            sorter: (a, b) => a.variant.length - b.variant.length || a.variant.localeCompare(b.variant),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('variant')
        },
        {
            title:'Quality',
            dataIndex:'quality',
            sorter: (a, b) => a.quality.length - b.quality.length || a.quality.localeCompare(b.quality),
            sortDirections: ['descend', 'ascend'],
            filters:Object.values(QualityTypeEnum).map(val => ({
                text: val,
                value: val
            })),
            filterMultiple: true,
            onFilter: (value, record) => {
                return record.quality == value;
            },
        },
        ...(tabName == 'degummingInfo' ? [
             {
                title:'In Quantity',
                dataIndex:'degumInQty',
                sorter: (a, b) => a.degumInQty - b.degumInQty,
                // sortDirections: ['descend', 'ascend'],
                render: (value) => Number(Number(value).toFixed(2))
            },
            {
                title:'Out Variant',
                dataIndex:'degumOutVariant',
                sorter: (a, b) => a.degumOutVariant.length - b.degumOutVariant.length || a.degumOutVariant.localeCompare(b.degumOutVariant),
                // sortDirections: ['descend', 'ascend'],
                ...getColumnSearchProps('degumOutVariant')
            },
            {
                title:'Out Quantity',
                dataIndex:'degumOutQty',
                sorter: (a, b) => a.degumOutQty - b.degumOutQty,
                // sortDirections: ['descend', 'ascend'],
                render:(text,record,index) => {
                    return(
                        <span>{Number(record.degumOutQty)}</span>
                    )
                }
            }
        ] : []),    
        ...(tabName == 'Open' ? [
             {
                title:'Degum Out Variant',
                dataIndex:'degumOutVariant',
                sorter: (a, b) => a.degumOutVariant.length - b.degumOutVariant.length || a.degumOutVariant.localeCompare(b.degumOutVariant),
                // sortDirections: ['descend', 'ascend'],
                ...getColumnSearchProps('degumOutVariant')
            },
        ] : []),
        {
            title:`${tabName == 'Assigned' ? 'Quantity' : 'Available Quantity'} `,
            dataIndex:'quantity',
            sorter: (a, b) => a.quantity - b.quantity,
            sortDirections: ['descend', 'ascend'],
            render:(text,record,index) => {
                return(
                    <span>{Number(record.quantity)}</span>
                )
            }
        },
        ...(tabName == 'Open' ? [
            {
                title:'Lot Quantity',
                dataIndex:'lotQuantity',
                render:(text,record,index) => {
                    return(
                        <Input value={Number(record.lotQuantity)} onChange={(e) => {onLotQuantityChange(e.target.value,index,record)}}/>
                    )
                }
            }
        ] : []),
        ...tabName == 'Assigned' ? [
            {
                title:'Yield%',
                dataIndex:'yield',
                render:(text,record) => {
                    return(
                        <>{Number((Number(record.quantity)/Number(record.lotQty)) * 100).toFixed(2)}</>
                    )
                }
            }
        ] : []
    ]

    const onLotQuantityChange = (val:any,index:number,record) => {
        if(Number(val) > Number(record.quantity)){
            AlertMessages.getErrorMessage('Lot Quantity cannot be greater than Available Quantity!')
            materialInfo[index].lotQuantity = Number(record.quantity)
            setMaterialInfo([...materialInfo])
        }else{
            materialInfo[index].lotQuantity = Number(val)
            setMaterialInfo([...materialInfo])
            const selectRowIndex = selectedRows.findIndex(e => e.prodInvId == record.prodInvId)
            if (selectRowIndex > -1) {
            selectedRows[selectRowIndex].lotQuantity = Number(val)
            setSelectedRows([...selectedRows])
            }
        }
    }

    const onAssignMaterial = (record:any) => {
        form.resetFields()
        setSelectedLotInfo(record)
        getMaterialToAssign()
        getLotVariants()
        setAssignMaterialModal(true)
    }


    const onTabChange = (val:any) => {
        setTabName(val)
        if(val == 'degummingInfo'){
            getMaterialToAssign()
        }else if(val == 'Open'){
            getOpenTabInfo()
        }else if(val == 'Assigned'){
            getAssignedLotInfo()
        }
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: (keys:any, rows:any) => {
            setSelectedRowKeys(keys);
            setSelectedRows(rows);
        },
    }

    useEffect(() => {
        let totQty = 0
        selectedRows.forEach((rec:any) => {
            totQty += Number(rec.lotQuantity)
        })
        setSelectedLotQty(totQty)
    },[selectedRows])

    const onSubmit = () => {
        if(selectedRows.length > 0){
            if(form.getFieldValue('lotVariant') != undefined){
                const materialInfo = []
                for(const rec of selectedRows){
                    materialInfo.push(new AssignLotMaterialReq(selectedLotInfo.lotNumber,rec.workOrderNumber,rec.lotQuantity,rec.prodInvId,userName,plantId,rec.variantId,rec.quality,form.getFieldValue('lotVariant'),form.getFieldValue('lotVariantName'),form.getFieldValue('lotQuality'),form.getFieldValue('date'),selectedLotInfo.year))
                }
                lotService.assignMaterialAgainstLot(materialInfo).then(res => {
                    if(res.status){
                        setAssignMaterialModal(false)
                        getOpenTabInfo()
                        setSelectedRowKeys([])
                        setSelectedRows([])
                        AlertMessages.getSuccessMessage(res.internalMessage)
                    }else{
                        AlertMessages.getErrorMessage(res.internalMessage)
                    }
                })
            }else{
                AlertMessages.getErrorMessage('Please select Variant')
            }
        }else{
            AlertMessages.getErrorMessage('Please select alteast one workorder to assign material to Lot!')
        }
    }

    const onReset = () => {
        if(tabName == 'degummingInfo'){
            degumInfoForm.resetFields()
        }else{
            form.resetFields()
        }

        getMaterialToAssign()
    }

    const onSearch = () => {
        getMaterialToAssign()
    }

    const onLotVariantChange = (val,option) => {
        form.setFieldsValue({lotVariantName:option?.productName})
    }

    useEffect(() => {
        const combinations = new Set(
            selectedRows.map(item => `${item.variant}_${item.quality}`)
        );
        const variant = combinations.size === 1 ? selectedRows[0].variantId : undefined;
        const variantName = combinations.size === 1 ? selectedRows[0].variant : undefined;
        const quality = combinations.size === 1 ? selectedRows[0].quality : undefined;
        form.setFieldsValue({ 'lotVariant': variant, 'lotQuality': quality,'lotVariantName': variantName})
    },[selectedRows])

    const onModalClose = () => {
        setAssignMaterialModal(false)
        setSelectedRows([])
        setSelectedRowKeys([])
        setSelectedLotQty(0)
    }
    
    return(
        <>
        <style>
    {`
      .child-table .ant-table-thead > tr > th {
        background-color: #f0f5ff !important;
        color: #000;
        font-weight: 500;
      }
    .child-table .ant-table-tbody > tr > td {
        background: #fff !important;
    }
        .child-table .ant-table-tbody > tr:hover > td {
        background: #fff !important;
    }
        .child-table .ant-table-column-sorter,
.child-table .ant-table-filter-trigger {
  color: #000 !important;
  opacity: 1 !important;
}
    `}
        </style>
        <Card title={<span style={{ color: 'white' }}>Lot Creation</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} 
         extra={<Button onClick={() => {history.push('/lot-creation')}}>Create Lot</Button>}>
            <Tabs onChange={onTabChange}>
                <TabPane key='degummingInfo' tab='Degumming Info'>
                    <Form form={degumInfoForm}>
                        <Row gutter={24}>
                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 5 }}>
                                <Form.Item name='workOrderNumber' label='Work Order Number'>
                                    <Select allowClear showSearch optionFilterProp="children" placeholder='Select Work Order' mode="multiple">
                                        {
                                            workOrderNumbers.map(e => {
                                                return(
                                                    <Option key={e.workOrderNumber} value={e.workOrderNumber}>{e.workOrderNumber}</Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                                <Form.Item name='variant' label='Variant'>
                                    <Select allowClear showSearch optionFilterProp="children" placeholder='Select Variant' mode="multiple">
                                        {
                                            variants.map(e => {
                                                return(
                                                    <Option key={e.variantId} value={e.variantId}>{e.variant}</Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                                <Form.Item name='quality' label='Quality'>
                                    <Select allowClear showSearch optionFilterProp="children" placeholder='Select Quality' mode="multiple">
                                        {
                                            Object.values(QualityTypeEnum).map(e => {
                                                return(
                                                    <Option key={e} value={e}>{e}</Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" onClick={onSearch}>Search</Button>
                            </Form.Item>
                            </Col>
                            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }}>
                            <Form.Item>
                                <Button onClick={onReset}>Reset</Button>
                            </Form.Item>
                            </Col>

                        </Row>
                    </Form>
                    <Table columns={assignMaterialColumns} dataSource={materialInfo} size='small'
                        summary={(pageData) => {
                            let totQty = 0
                            let totInQty = 0
                            let totOutQty = 0
                            pageData.forEach(({quantity,degumInQty,degumOutQty}) => {
                                totQty += Number(quantity)
                                totInQty += Number(degumInQty)
                                totOutQty += Number(degumOutQty)
                            })
                            return(
                                <>
                                    <Table.Summary.Row className="tableFooter">
                                        <Table.Summary.Cell index={0} colSpan={4} align='right'>Total</Table.Summary.Cell>
                                        <Table.Summary.Cell index={5} align='left'>{totInQty}</Table.Summary.Cell>
                                        <Table.Summary.Cell index={6} align='left'>{totOutQty}</Table.Summary.Cell>
                                        <Table.Summary.Cell index={7} align='left'>{totQty}</Table.Summary.Cell>
                                    </Table.Summary.Row>
                                </>
                            )
                        }}
                    />    
                </TabPane>
                <TabPane key='Open' tab='OPEN'>
                    <Table columns={columns} dataSource={openTabInfo} size='small'/>    
                </TabPane>
                <TabPane key='Assigned' tab='ASSIGNED'>
                    <Table columns={columns} dataSource={assignedTabInfo} size='small' rowKey={record => record.lotNumber}
                        expandable={{
                            expandedRowRender:(record) => (
                            <div style={{ padding: '12px 24px', background: '#fafafa' }}>

                                <Table columns={assignMaterialColumns} dataSource={record.materialInfo} size='small' pagination={false} className="child-table"/>
                            </div>
                            ),
                        expandIconColumnIndex: columns.length + 1,
                        }}
                    />
                </TabPane>
            </Tabs>
            <Modal visible={assignMaterialModal} onCancel={() => {onModalClose()}} footer={[<Button type='primary' onClick={onSubmit}>Submit</Button>]} width={'80%'} title='Assign Material'>
            {/* <Card title='Assign Material' style={{textAlign:'center'}}> */}
                <Form form={form} initialValues={{date: moment()}}>
                    <Row gutter={24}>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 6 }}>
                            <Form.Item name='workOrderNumber' label='Work Order Number'>
                                <Select allowClear showSearch optionFilterProp="children" placeholder='Select Work Order' mode="multiple">
                                    {
                                        workOrderNumbers.map(e => {
                                            return(
                                                <Option key={e.workOrderNumber} value={e.workOrderNumber}>{e.workOrderNumber}</Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 5 }}>
                            <Form.Item name='variant' label='Variant'>
                                <Select allowClear showSearch optionFilterProp="children" placeholder='Select Variant' mode="multiple">
                                    {
                                        variants.map(e => {
                                            return(
                                                <Option key={e.variantId} value={e.variantId}>{e.variant}</Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                            <Form.Item name='quality' label='Quality'>
                                <Select allowClear showSearch optionFilterProp="children" placeholder='Select Quality' mode="multiple">
                                    {
                                        Object.values(QualityTypeEnum).map(e => {
                                            return(
                                                <Option key={e} value={e}>{e}</Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" onClick={onSearch}>Search</Button>
                        </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }}>
                        <Form.Item>
                            <Button onClick={onReset}>Reset</Button>
                        </Form.Item>
                        </Col>

                    </Row>
                    <Card>
                        <Descriptions>
                            <DescriptionsItem label='Lot Number'>{selectedLotInfo?.lotNumber}</DescriptionsItem>
                            <DescriptionsItem label='Lot Type'>{selectedLotInfo?.lotType}</DescriptionsItem>
                            <DescriptionsItem label='Remarks'>{selectedLotInfo?.remarks}</DescriptionsItem>
                        </Descriptions>
                            <Row gutter={24}>
                                <Form.Item name='lotVariantName' hidden>
                                    <Input/>
                                </Form.Item>
                                <Form.Item name='lotQuality' hidden>
                                    <Input/>
                                </Form.Item>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 5 }}>
                                    <Form.Item name='date' label='Date'>
                                        <DatePicker style={{width:'100%'}}/>
                                    </Form.Item>
                                </Col>
                                <Col  xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 6 }}>
                                    <Form.Item label={<><div style={{color:'red'}}>*</div> Lot Variant</>} name='lotVariant' >
                                        <Select allowClear showSearch optionFilterProp="children" placeholder='Select Variant' onChange={onLotVariantChange}>
                                            {
                                                lotVariants.map(e => {
                                                    return(
                                                        <Option key={e.productId} value={e.productId} productName={e.productName}>{e.productName}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col  xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 5 }} style={{marginLeft:'20%'}}>
                                    <Descriptions>
                                        <DescriptionsItem label={<b>Selected Quantity</b>}>{selectedLotQty}</DescriptionsItem>
                                    </Descriptions>
                                </Col>
                            </Row>
                        <Table columns={assignMaterialColumns} dataSource={materialInfo} rowKey={(record,index) => record.workOrderNumber + '-' + index}
                        size="small"
                            rowSelection={{...rowSelection}}
                            summary={(pageData) => {
                                let totQty = 0
                                pageData.forEach(({quantity}) => {
                                    totQty += Number(quantity)
                                })
                                return(
                                    <>
                                        <Table.Summary.Row className="tableFooter">
                                            <Table.Summary.Cell index={0} colSpan={6} align='right'>Total</Table.Summary.Cell>
                                            <Table.Summary.Cell index={7} align='left'>{totQty}</Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    </>
                                )
                            }}
                        />
                    </Card>
                </Form>
                        
            {/* </Card> */}
            </Modal>
        </Card>
        </>
    )

}

export default LotView